export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
  },
  getters: {
    currentCenterId(state) {
      return state.id
    },
    currentCenterName(state) {
      return state.name
    },
  },
  mutations: {
    UPDATE_CENTER_ID(state, val) {
      state.id = val
    },
    UPDATE_CENTER_NAME(state, val) {
      state.name = val
    },
  },
  actions: {},
}
